// ─── Site-wide config (update before deploying) ────────────────────────────
export const KOFI_URL = 'https://ko-fi.com/riannaelisse';
export const GUMROAD_URL = 'https://riannaelisse.gumroad.com/coffee';
export const ADSENSE_SLOT = 'YOUR_AD_SLOT_ID'; // TODO: replace with slot ID from AdSense dashboard
export const ADSENSE_CLIENT = 'ca-pub-7085446449789951';
export const CONSENT_KEY = 'purgr_cookie_consent';
export const CONTACT_EMAIL = 'founder@purgr.com'; // TODO: update with real email
// ────────────────────────────────────────────────────────────────────────────
